import { IMAGE_VERSION } from '@/shared/constants/appConstants';

/**
 * Builds a cache-bustable URL for a file in `quadratic-client/public/images`.
 *
 * Public images are served with a long-lived `immutable` Cache-Control, so the
 * request URL must change whenever the bytes change or returning users (and the
 * CDN edge) keep serving the stale copy. The `?v=IMAGE_VERSION` query provides
 * that invalidation: bump `IMAGE_VERSION` in appConstants.ts whenever you add or
 * replace anything under public/images.
 *
 * Static references in index.html cannot use this helper; they are busted with
 * Vite's `%VITE_VERSION%` substitution instead.
 */
export const imageUrl = (path: string): string => `${path}?v=${IMAGE_VERSION}`;
